export const SkillsData=[
    {
        type:'Languages',
        list: [
            {
                name: 'Python',
                icon: <i class="devicon-python-plain colored"></i>
            }
            ,{
                name: 'Javascript',
                icon: <i class="devicon-javascript-plain colored"></i>
            },
            // {
            //     name: 'C#',
            //     icon: <i class="devicon-visualstudio-plain colored"></i>

            // }

        ]
    },
    {
        type:"Frontend/Web",
        list: [
            {
                name: 'ReactJS',
                icon: <i class="devicon-react-original colored"></i>
            },
            // {
            //     name: 'HTML',
            //     icon: <i class="devicon-html5-plain colored"></i>
            // },
            {
                name: 'Typescript',
                icon: <i class="devicon-typescript-plain colored"></i>
            },
            // {
            //     name: 'CSS',
            //     icon: <i class="devicon-css3-plain colored"></i>
            // }
            ,
            {
                name: 'TailwindCSS',
                icon: <i class="devicon-tailwindcss-plain colored"></i>
              
            }

        ]
    },
    {
        type:'Backend/Data',
        list: [
            {
                name: "FastAPI",
                icon: <i class="devicon-fastapi-plain colored"></i>    
            },
            {
                name: "Express",
                icon: <i class="devicon-express-original colored"></i>
            },
            {
                name: "Flask",
                icon: <i class="devicon-flask-original colored"></i>
            },
            {
                name: "Postgres",
                icon: <i class="devicon-postgresql-plain colored"></i>
            },
            {
                name: "SQLite",
                icon: <i class="devicon-mysql-plain colored"></i>
            },
            {
                name: "MongoDB",
                icon: <i class="devicon-mongodb-plain colored"></i>
            },
            /*
            {
                name: "kdb+",
                icon: "kx"
            }*/

        ]
    },
    {
        type:'Gen AI/ML',
        list: [
            {
                name: "SemanticKernel",
                icon: <i class="skill-icon"><img className="skill-img" src="/sk_logo_1.png"/></i>
            },
            {
                name: "LangGraph",
                icon: <i class="skill-icon"><img className="skill-img" src="/langgraph_1.png"/></i>
            },
            {
                name: "Llama Index",
                icon: <i class="skill-icon"><img className="skill-img" src="/llama.jpeg"/></i>
            },
            {
                name: "PineCone",
                icon: <i class="skill-icon"><img className="skill-img" src="/pinecone.png"/></i>
            },
            {
                name: "OpenAI",
                icon: <i class="skill-icon"><img className="skill-img" src="/openai.png"/></i>
            },
            // {
            //     name: "TensorFlow",
            //     icon: <i class="devicon-tensorflow-original colored"></i>
            // },
        ]
    },
    {
        type:'Technologies',
        list: [
            
            {
                name: "Azure",
                icon: <i class="devicon-azure-plain colored"></i>
            },
            {
                name: "GCP",
                icon: <i class="devicon-googlecloud-plain-wordmark"></i>
            },
            {
                name: "Docker",
                icon: <i class="devicon-docker-plain colored"></i>
            },
            {
                name: "Kubernetes",
                icon: <i class="devicon-kubernetes-plain colored"></i>
            },
            // {
            //     name: "Unity",
            //     icon: <i class="devicon-unity-original colored"></i>
            // },
            /*
            {
                name: ".Net",
                icon: <i class="devicon-dotnetcore-plain colored"></i>
            },*/
            

        ]
    },
    

]